var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-information section-box"},[_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.tabId),callback:function ($$v) {_vm.tabId=$$v},expression:"tabId"}},[_c('el-tab-pane',{attrs:{"name":"id_1","label":"大客户配置","lazy":""}},[_c('vip-allocation-edit',{ref:"vipAllocationEdit"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }